import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../Assets/castlelogo.png";

import {
  GetUserCommand,
  ConfirmSignUpCommand,
  SignUpCommand,
  InitiateAuthCommand,
  ForgotPasswordCommand,
  ConfirmForgotPasswordCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { cognitoClient, userPoolID, clientID } from "../Components/aws-config";

import {
  LaptopOutlined,
  NotificationOutlined,
  UserOutlined,
  MailOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Typography,
  Layout,
  Menu,
  theme,
  Image,
  Flex,
  Modal,
  message,
} from "antd";

const { Title } = Typography;

function Login() {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const { Header, Content, Footer, Sider } = Layout;
  const items1 = ["1", "2", "3"].map((key) => ({
    key,
    label: `nav ${key}`,
  }));
  const items2 = [UserOutlined, LaptopOutlined, NotificationOutlined].map(
    (icon, index) => {
      const key = String(index + 1);
      return {
        key: `sub${key}`,
        icon: React.createElement(icon),
        label: `subnav ${key}`,
        items: new Array(4).fill(null).map((_, j) => {
          const subKey = index * 4 + j + 1;
          return {
            key: subKey,
            label: `option${subKey}`,
          };
        }),
      };
    },
  );

  const navigate = useNavigate();
  document.title = "Sign in | Hansoftware";
  const [signUpVisible, setSignUpVisible] = useState(false);
  const [signUpEmail, setSignUpEmail] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [signUpPassword, setSignUpPassword] = useState("");

  const [step, setStep] = useState(1); // 1 = enter email, 2 = enter code + new password
  const [email, setEmail] = useState("");
  const [cogCode, setCogCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [newPassVisible, setNewPassVisible] = useState(false);
  const [passwordRequirementsVisible, setPasswordRequirementsVisible] = useState(false);
  
  const [sessionToken, setSessionToken] = useState("");
  const [challengeName, setChallengeName] = useState("");

  const [verifyVisible, setVerifyVisible] = useState(false);
  //const [code, setCode] = useState("");

  const [submitLoading, setSubmitLoading] = useState(false);
  const [signUpLoading, setSignUpLoading] = useState(false);

  const handleSignUp = async () => {
    try {
      console.log("name: ", name);
      console.log("phone: ", phoneNumber);
      console.log("address: ", address);
      const command = new SignUpCommand({
        ClientId: clientID,
        Username: signUpEmail,
        Password: signUpPassword,
        UserAttributes: [
          {
            Name: "name",
            Value: name,
          },
          {
            Name: "phone_number",
            Value: phoneNumber,
          },
          {
            Name: "address",
            Value: address,
          },
        ],
      });

      const response = await cognitoClient.send(command);
      console.log("Sign up successful:", response);
      setSignUpVisible(false);
      setVerifyVisible(true);
    } catch (error) {
      console.error("Error signing up:", error);
    }
  };

  const handleVerifyEmail = async () => {
    try {
      console.log("name: ", name);
      console.log("phone: ", phoneNumber);
      console.log("address: ", address);
      const command = new ConfirmSignUpCommand({
        ClientId: clientID,
        Username: signUpEmail,
        ConfirmationCode: cogCode,
      });

      const response = await cognitoClient.send(command);
      console.log("Code verification successful:", response);
      setVerifyVisible(false);
    } catch (error) {
      console.error("Error with code:", error);
      // show error, allow user to try code again
    }
  };

  const handleNewPassword = async () => {
    
    try {
      console.log("email: ", email)
      console.log("name: ", name);
      console.log("phone: ", phoneNumber);
      console.log("address: ", address);
      const command = new RespondToAuthChallengeCommand({
        ClientId: clientID,
        ChallengeName: challengeName,
        Session: sessionToken,
        ChallengeResponses: {
          USERNAME: email,
          NEW_PASSWORD: newPassword
        }
      });

      const response = await cognitoClient.send(command);
      setNewPassVisible(false);
      message.success("Success, please log in with your new password.", 20)
      handleLogin(email, newPassword)
    } catch (error) {
      message.error("Error resetting password:", error)
    }
  };

  const onFinish = (values) => {
    handleLogin(values.email, values.password)
      .then((response) => {
        if (response === "SUCCESS") {
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        // show error
        console.log(error);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    // show error
  };

  const handleLogin = async (email, password) => {
    setEmail(email)
    setSubmitLoading(true);
    try {
      const command = new InitiateAuthCommand({
        AuthFlow: "USER_PASSWORD_AUTH",
        ClientId: clientID,
        AuthParameters: {
          USERNAME: email,
          PASSWORD: password,
        },
      });

      const response = await cognitoClient.send(command);
      console.log(response);
      console.log(response.ChallengeName);
      if (response.ChallengeName === "NEW_PASSWORD_REQUIRED") {
        setNewPassVisible(true);
        // launch modal, have user enter new password, etc.
        setSessionToken(response.Session);
        setChallengeName(response.ChallengeName);
        //setSubmitLoading(false);
        return "forceNewPass"
      } else {
        const { IdToken, AccessToken, RefreshToken, ExpiresIn } =
          response.AuthenticationResult;
        const expirationTime = Date.now() + ExpiresIn * 1000; // ExpiresIn is in seconds, date is in milliseconds
        // may change this to localForage in the future for JSON support
        localStorage.setItem("accessToken", AccessToken);
        localStorage.setItem("idToken", IdToken);
        localStorage.setItem("refreshToken", RefreshToken);
        localStorage.setItem("tokenExpiration", expirationTime);
        // get name, email, etc.
        getUserAttributes(AccessToken);

        // Get signed CloudFront cookie from Lambda
        try {
          await axios.get(`https://api.hansoftware.net/getS3Cookie`, {
            withCredentials: true, // key part for cookies
            headers: {
              Authorization: `Bearer ${IdToken}`, // from your Cognito login response
            },
          });
          //console.log(response);
          console.log("Got cookie successfully");
        } catch (error) {
          console.error("Failed to fetch cookie", error);
        }
        setSubmitLoading(false);
        return "SUCCESS";
      }
    } catch (error) {
      setSubmitLoading(false)
      const errMsg = error instanceof Error ? error.message : String(error);
      message.error("Login failed. Please check your email and password and try again. If the issue persists, contact your administrator.", 10)
      //console.error("Error logging in:", errMsg);
    }
  };

  const getUserAttributes = async (accessToken) => {
    try {
      const command = new GetUserCommand({
        AccessToken: accessToken,
      });
      const response = await cognitoClient.send(command);
      //console.log("User logged in");
      //console.log(response);
      const userAttributes = response.UserAttributes;
      const nameAttribute = userAttributes.find((attr) => attr.Name === "name");
      const emailAttribute = userAttributes.find(
        (attr) => attr.Name === "email",
      );
      const userFullName = nameAttribute ? nameAttribute.Value : null;
      const userEmail = emailAttribute ? emailAttribute.Value : null;
      localStorage.setItem("email", userEmail);
      localStorage.setItem("name", userFullName);
    } catch (error) {
      console.log("User not logged in!");
      console.error(error);
    }
  };

  // PASSWORD RESET
  const sendResetCode = async () => {
    if (!email) return message.error("Please enter your email", 10);
    setLoading(true);
    try {
      await cognitoClient.send(
        new ForgotPasswordCommand({
          ClientId: clientID,
          Username: email,
        }),
      );
      message.success("Verification code sent to your email", 15);
      setStep(2);
    } catch (err) {
      message.error(err.message || "Error sending verification code", 10);
    }
    setLoading(false);
  };

  const confirmNewPassword = async () => {
    if (!cogCode || !newPassword) {
      return message.error("Please enter all fields", 10);
    }
    setLoading(true);
    try {
      await cognitoClient.send(
        new ConfirmForgotPasswordCommand({
          ClientId: clientID,
          Username: email,
          ConfirmationCode: cogCode,
          Password: newPassword,
        }),
      );
      message.success("Password reset successful! Please log in.", 10);
      setResetVisible(false);
      setStep(1);
      setEmail("");
      setCogCode("");
      setNewPassword("");
    } catch (err) {
      message.error(err.message || "Error confirming new password", 10);
    }
    setLoading(false);
  };

  return (
    <div style={{ flex: 1 }}>
      <Layout>
        <Modal
          title="New Password Required"
          open={newPassVisible}
          onCancel={() => {
            setNewPassVisible(false);
            setStep(1);
            setEmail("");
            setCogCode("");
            setNewPassword("");
          }}
          footer={
                  <Button key="cancel" onClick={() => console.log("You must set your password!")}>
                    Cancel
                  </Button>,
                  <Button
                    key="confirm"
                    type="primary"
                    loading={loading}
                    onClick={() => {
                      // do password policy checking here before handling
                      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                      const validPassword = passwordRegex.test(newPassword)
                      if (validPassword) {
                        handleNewPassword()
                        message.success("Password reset successfully.", 10)
                        
                      } else {
                        message.error("Password does not meet the requirements.", 10);
                        setPasswordRequirementsVisible(true)
                      }
                    }}
                  >
                    Submit
                  </Button>
          }
        >
          {passwordRequirementsVisible ?
          <p>
            Password Requirements:
            <br />
            <ul>
              <li>Minimum 8 characters</li>
              <li>At least one uppercase letter</li>
              <li>At least one lowercase letter</li>
              <li>At least one number</li>
              <li>At least one special character (e.g., @, $, !, %, *, ?, &)</li>
            </ul>
          </p>
          : ""}
          {step === 1 && (
            <>
              <Input.Password
                placeholder="New password"
                value={newPassword}
                onChange={(e) => {setNewPassword(e.target.value)}}
              />
            </>
          )}
        </Modal>
        <Modal
          title="Reset Password"
          open={resetVisible}
          onCancel={() => {
            setResetVisible(false);
            setStep(1);
            setEmail("");
            setCogCode("");
            setNewPassword("");
          }}
          footer={
            step === 1
              ? [
                  <Button key="cancel" onClick={() => setResetVisible(false)}>
                    Cancel
                  </Button>,
                  <Button
                    key="send"
                    type="primary"
                    loading={loading}
                    onClick={() => sendResetCode()}
                  >
                    Send Code
                  </Button>,
                ]
              : [
                  <Button
                    key="cancel"
                    onClick={() => {
                      setResetVisible(false);
                      setStep(1);
                    }}
                  >
                    Cancel
                  </Button>,
                  <Button
                    key="confirm"
                    type="primary"
                    loading={loading}
                    onClick={() => confirmNewPassword()}
                  >
                    Reset Password
                  </Button>,
                ]
          }
        >
          {step === 1 && (
            <Input
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
          )}
          {step === 2 && (
            <>
              <Input
                placeholder="Verification code"
                value={cogCode}
                onChange={(e) => setCogCode(e.target.value)}
                style={{ marginBottom: 12 }}
                autoFocus
              />
              <Input.Password
                placeholder="New password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </>
          )}
        </Modal>
        <Content
          style={{
            padding: "40px",
          }}
        >
          <Flex
            style={{
              width: "40%",
              textAlign: "center",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Layout
              style={{
                //width: "100%",
                padding: "50px",
                background: colorBgContainer,
                borderRadius: "50px",
                //maxWidth: "50vw",
              }}
            >
              <Content
                style={{
                  minHeight: 300,
                }}
              >
                <Title style={{ marginTop: "10px", paddingBottom: "40px" }}>
                  Sign in
                </Title>
                <Form
                  name="basic"
                  labelAlign="left"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  size={"large"}
                >
                  <Form.Item
                    label={<span style={{ fontSize: "18px" }}>Email</span>}
                    name="email"
                    icon={<MailOutlined />}
                    rules={[
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ fontSize: "18px" }}>Password</span>}
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>
                  <Form.Item
                    style={{
                      float: "left",
                    }}
                  >
                    <Button
                      color="default"
                      variant="filled"
                      style={{ fontSize: 20, padding: 20 }}
                      loading={signUpLoading}
                      onClick={() => {
                        setResetVisible(true);
                      }}
                    >
                      Reset password
                    </Button>
                  </Form.Item>
                  <Form.Item
                    style={{
                      float: "right",
                    }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ fontSize: 20, padding: 20 }}
                      loading={submitLoading}
                      // onClick={() => {
                      //   handleLogin(email, password)
                      // }}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Content>
            </Layout>
          </Flex>
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontSize: 16,
          }}
        >
          Hansoftware © {new Date().getFullYear()}
        </Footer>
      </Layout>
    </div>
  );
}

export default Login;
